import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { Toaster, toast } from "react-hot-toast";

/* -------------------- CONFIG -------------------- */
const BASE_URL = process.env.REACT_APP_BASEURL;

/* -------------------- COMPONENT -------------------- */

function CouponText() {
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm();

    const [loading, setLoading] = useState(false);

    /* -------------------- GET COUPON TEXT -------------------- */

    const fetchCouponText = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("astroVani-admin-token");

            const res = await axios.get(`${BASE_URL}/admin/couponText`, {
                headers: {
                    Authorization: token,
                },
            });

            const data = res?.data?.data;

            if (data) {
                setValue("value", data.value || "");
            }
        } catch (err) {
            console.error("Failed to load coupon text", err);
            // toast.error("Failed to load coupon text");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCouponText();
    }, []);

    /* -------------------- UPDATE COUPON TEXT -------------------- */

    const onSubmit = async (formData) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("astroVani-admin-token");

            const payload = {
                value: formData.value,
            };

            const res = await axios.post(
                `${BASE_URL}/admin/couponText`,
                payload,
                {
                    headers: {
                        Authorization: token,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (res?.data?.success || res?.status === 200 || res?.status === 201) {
                toast.success("Coupon text updated successfully");
            } else {
                toast.error("Update failed");
            }
        } catch (err) {
            console.error("Error updating coupon text", err);
            toast.error("Something went wrong while updating");
        } finally {
            setLoading(false);
        }
    };

    /* -------------------- UI -------------------- */

    return (
        <div className="container-fluid">
            <Toaster position="top-right" />
            <div className="row g-3 mb-3 align-items-center">
                <div className="col">
                    <h1 className="h3 mt-2">Coupon Text Management</h1>
                </div>
            </div>

            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card mb-3">
                        <div className="card-body">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row g-3">
                                    <div className="col-sm-12">
                                        <label className="form-label">Coupon Text</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter coupon text (e.g., Coupon Code applied)"
                                            {...register("value", {
                                                required: "Coupon text is required",
                                            })}
                                        />
                                        {errors.value && (
                                            <span className="text-danger">
                                                {errors.value.message}
                                            </span>
                                        )}
                                    </div>

                                    <div className="col-sm-12 mt-4">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? "Updating..." : "Update Coupon Text"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CouponText;
